function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M6.66699 8.33333V5.83333V5.83333C6.66699 3.9925 8.15949 2.5 10.0003 2.5V2.5C11.8412 2.5 13.3337 3.9925 13.3337 5.83333V5.83333V8.33333",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = React.createElement("path", {
  d: "M9.99967 11.6667V14.1667",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.167 17.4999H5.83366C4.91283 17.4999 4.16699 16.7541 4.16699 15.8333V9.99992C4.16699 9.07909 4.91283 8.33325 5.83366 8.33325H14.167C15.0878 8.33325 15.8337 9.07909 15.8337 9.99992V15.8333C15.8337 16.7541 15.0878 17.4999 14.167 17.4999Z",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.1031e044.svg";
export { ForwardRef as ReactComponent };